// src/Pages/Load/LoadContainer/components/VehicleBentoBox.jsx

"use client";

import React, { useState } from "react";
import { TbTruck, TbFileText } from "react-icons/tb";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../../Components/ui/dropdown-menu";
import { Button } from "../../../../Components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../../../Components/ui/dialog";
import { Label } from "../../../../Components/ui/label";

import BentoBox from "./BentoBox";

export default function VehicleBentoBox({
  vehicles,
  invoicePdfPath,
  onEditVehicles,
  onOpenBOL,
  onOpenInvoice,
  isPickedUp,
  className,
  onStatusUpdate,
  currentStatus,
  showStatusButton,
  showBOLButton, // mantido por compatibilidade
  selectedLoad,
  userRoleId, // mantido por compatibilidade (mesmo usando window.userRoleId no original)
}) {
  const [isSelectVehicleModalOpen, setIsSelectVehicleModalOpen] = useState(false);
  const [isAllPdfsModalOpen, setAllPdfsModalOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [pdfs, setPdfs] = useState([]);
  const [pdfType, setPdfType] = useState("all");

  const handleOpenPDF = (type) => {
    setPdfType(type);
    setIsSelectVehicleModalOpen(true);
  };

  const handleOpenBOLForVehicle = (vehicle) => {
    // Mantido como no original (somente logs)
    console.log("Abrir BOL para:", vehicle);
    console.log(" selectedLoad:", selectedLoad?.load_items);
    console.log("pickup_bol_path do selectedLoad:", selectedLoad?.pickup_bol_path);
    console.log("pickup_bol_path do vehicle:", vehicle?.pickup_bol_path);
  };

  const getVehicleBolPath = (vehicle) => {
    return vehicle?.dropoff_bol_path || vehicle?.pickup_bol_path || null;
  };

  const showInspectionTypeButton = (inspection_load_item) => {
    if (currentStatus === "New") {
      return null;
    }

    const pickupInspectionExists =
      Array.isArray(inspection_load_item?.inspection_load_items) &&
      inspection_load_item.inspection_load_items.some(
        (item) => item.inspection_type === "Pickup"
      );

    const deliveryInspectionExists =
      Array.isArray(inspection_load_item?.inspection_load_items) &&
      inspection_load_item.inspection_load_items.some(
        (item) => item.inspection_type === "Delivery"
      );

    const allInspectionsComplete = pickupInspectionExists && deliveryInspectionExists;
    const shouldShowPickupButton = !pickupInspectionExists && !allInspectionsComplete;
    const shouldShowDeliveryButton =
      pickupInspectionExists && !deliveryInspectionExists && !allInspectionsComplete;

    return shouldShowPickupButton ? (
      [1, 2, 4, 7].includes(window.userRoleId) ? (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            window.location.href =
              "/InspectionLoadItem?load_item_id=" + inspection_load_item.id;
          }}
        >
          Start Pickup
        </Button>
      ) : null
    ) : shouldShowDeliveryButton ? (
      [1, 2, 4, 7].includes(window.userRoleId) ? (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            window.location.href =
              "/InspectionLoadItem?load_item_id=" + inspection_load_item.id;
          }}
        >
          Start Delivery
        </Button>
      ) : null
    ) : null;
  };

  const handleVehicleSelect = () => {
    if (selectedVehicle) {
      setIsSelectVehicleModalOpen(false);

      // Mantido como mock (igual original)
      let mockPdfs = [
        { name: "Vehicle_BOL.pdf", id: 1, type: "BOL" },
        { name: "Vehicle_Invoice.pdf", id: 2, type: "Invoice" },
        { name: "Vehicle_Inspection.pdf", id: 3, type: "Other" },
      ];

      if (pdfType !== "all") {
        mockPdfs = mockPdfs.filter((pdf) => pdf.type === pdfType);
      }

      setPdfs(mockPdfs);
      setAllPdfsModalOpen(true);
    }
  };

  const handleDeletePdf = (pdfId) => {
    setPdfs(pdfs.filter((pdf) => pdf.id !== pdfId));
  };

  return (
    <BentoBox title="Vehicles" icon={TbTruck} className={className}>
      <div className="max-h-40 overflow-y-auto">
        {vehicles.map((vehicle, index) => {
          const vehicleBolPath = getVehicleBolPath(vehicle);
          const hasAnyPdfOption = !!vehicleBolPath || !!invoicePdfPath;

          return (
            <div key={index} className="mb-4 p-2 border-b border-gray-700">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <img
                    src={
                      vehicle.image ||
                      "https://new.cajuu.app/storage/profile_load_item_pictures/vehicle_profile_dark.webp"
                    }
                    alt={`${vehicle.make} ${vehicle.model}`}
                    width={50}
                    height={50}
                    className="mr-3 rounded"
                  />

                  <p className="text-sm text-white">
                    {vehicle.year} {vehicle.make} {vehicle.model} -{" "}
                    <span className={vehicle.is_operable ? "text-green-400" : "text-red-400"}>
                      {vehicle.is_operable ? "OP" : "INOP"}
                    </span>
                  </p>
                </div>

                <div className="flex items-center gap-2">
                  {showInspectionTypeButton(vehicle)}

                  {isPickedUp && hasAnyPdfOption && (
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="outline" size="sm">
                          <TbFileText className="mr-1" />
                          Open PDF
                        </Button>
                      </DropdownMenuTrigger>

                      <DropdownMenuContent>
                        {vehicleBolPath && (
                          <DropdownMenuItem onSelect={() => onOpenBOL(vehicleBolPath)}>
                            Open BOL
                          </DropdownMenuItem>
                        )}

                        {invoicePdfPath && (
                          <DropdownMenuItem onSelect={() => onOpenInvoice(invoicePdfPath)}>
                            Open Invoice
                          </DropdownMenuItem>
                        )}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex mt-2 gap-2">
        <Button variant="outline" size="sm" onClick={onEditVehicles}>
          Vehicles Details
        </Button>
      </div>

      {showStatusButton && [1, 2, 4, 7].includes(window.userRoleId) && (
        <div className="flex justify-end mt-2 gap-2">
          <Button
            size="sm"
            onClick={onStatusUpdate}
            className="bg-green-500 text-white hover:bg-green-600"
          >
            {currentStatus === "New"
              ? "Assign"
              : currentStatus === "Assigned"
              ? "Confirm"
              : currentStatus === "Confirmed"
              ? "Mark as Picked Up"
              : currentStatus === "Picked Up"
              ? "Mark as Dropped Off"
              : currentStatus === "Dropped Off"
              ? "Mark as Delivered"
              : currentStatus === "Delivered"
              ? "Mark as Billed"
              : currentStatus === "Billed"
              ? "Mark as Paid"
              : "Next Status"}
          </Button>
        </div>
      )}

      <Dialog open={isSelectVehicleModalOpen} onOpenChange={setIsSelectVehicleModalOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Select Vehicle</DialogTitle>
          </DialogHeader>

          <div className="mt-4 relative">
            <Label
              htmlFor="vehicle"
              className="absolute -top-[10px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Select Vehicle <span className="text-rose-500">*</span>
            </Label>

            <select
              id="vehicle"
              value={selectedVehicle}
              onChange={(e) => setSelectedVehicle(e.target.value)}
              className="w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            >
              {vehicles.map((vehicle, index) => (
                <option
                  className="bg-zinc-800 text-white"
                  key={index}
                  value={`${vehicle.make} ${vehicle.model}`}
                >
                  {vehicle.year} {vehicle.make} {vehicle.model} -{" "}
                  {vehicle.is_operable ? "OP" : "INOP"}
                </option>
              ))}
            </select>
          </div>

          <DialogFooter>
            <Button onClick={handleVehicleSelect}>View PDFs</Button>
            <Button onClick={() => setIsSelectVehicleModalOpen(false)} variant="outline">
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={isAllPdfsModalOpen} onOpenChange={setAllPdfsModalOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{pdfType === "all" ? "All PDFs" : `${pdfType} PDFs`}</DialogTitle>
          </DialogHeader>

          <div className="mt-4">
            <h4 className="font-semibold mb-2 text-white">PDFs for {selectedVehicle}:</h4>

            <ul className="space-y-2">
              {pdfs.map((pdf) => (
                <li key={pdf.id} className="flex items-center justify-between text-white">
                  <span>{pdf.name}</span>
                  <Button variant="outline" size="sm" onClick={() => handleDeletePdf(pdf.id)}>
                    Delete
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          <DialogFooter>
            <Button onClick={() => setAllPdfsModalOpen(false)}>Close</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </BentoBox>
  );
}